import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Button, Dropdown, Menu, Row, Skeleton, Spin } from "antd";
import moment from "moment";

import summaryApi from "../../../apis/Summary.api";

const DashboardCategory = () => {
	const [loading, setLoading] = useState(false);
	const [soarLoading, setSoarLoading] = useState(false);
	const user = useSelector((state) => state.auth.user);

	const [totalCount, setTotalCount] = useState(0);
	const [categoryList, setCategoryList] = useState([]);
	const [dateLength, setDateLength] = useState(2);
	const [soarList, setSoarList] = useState([]);

	const convertCategory = (item) => {
		if (item?.category_type === "ingredient") {
			return `성분별 > ${item.category_name}`;
		} else if (item?.category_type === "function") {
			return `고민별 > ${item.category_name}`;
		} else if (item?.category_type === "combination") {
			return `조합별 > ${item.category_name}`;
		} else if (item?.category_type === "community") {
			return `소통`;
		}
	};

	useEffect(() => {
		if (user?.id) {
			getDashboardCategory();
		}
	}, [user]);

	const getDashboardCategory = useCallback(async () => {
		setLoading(true);
		const param = {
			offset: 0,
			pageSize: 5,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			startDate: moment()
				.subtract(30, "months")
				.startOf("days")
				.format("YYYYMMDDHHmm"),
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
		};
		const res = await summaryApi.readDashboardCategory(param);
		if (res.code === 200) {
			setTotalCount(res.result?.total_cnt ?? 0);
			setCategoryList(res.result?.categoryList ?? []);
		}
		setLoading(false);
	}, []);

	useEffect(() => {
		getSoaringCategory();
	}, [dateLength]);

	const getSoaringCategory = useCallback(async () => {
		setSoarLoading(true);
		const param = {
			offset: 0,
			pageSize: 5,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			dateType: 0,
			startDate: moment()
				.subtract(dateLength, "days")
				.startOf("days")
				.format("YYYYMMDDHHmm"),
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
		};
		const res = await summaryApi.readDashboardCategorySoaring(param);
		if (res.code === 200) {
			setSoarList(res.result);
		}
		setSoarLoading(false);
	}, [dateLength]);

	const dropdownItems = (
		<Menu>
			<Menu.Item
				style={{ fontSize: "0.9em" }}
				onClick={() => {
					setDateLength(1);
				}}
			>
				1일 전
			</Menu.Item>
			<Menu.Item
				style={{ fontSize: "0.9em" }}
				onClick={() => {
					setDateLength(2);
				}}
			>
				2일 전
			</Menu.Item>
			<Menu.Item
				style={{ fontSize: "0.9em" }}
				onClick={() => {
					setDateLength(3);
				}}
			>
				3일 전
			</Menu.Item>
			<Menu.Item
				style={{ fontSize: "0.9em" }}
				onClick={() => {
					setDateLength(7);
				}}
			>
				일주일 전
			</Menu.Item>
			<Menu.Item
				style={{ fontSize: "0.9em" }}
				onClick={() => {
					setDateLength(30);
				}}
			>
				한달 전
			</Menu.Item>
		</Menu>
	);

	return (
		<div className={`dashboard-body-each`}>
			<h2 className={`dashboard-each-title`}>카테고리 분석</h2>
			<div
				className={`dashboard-each-data-div`}
				style={{ border: "none", padding: 0 }}
			>
				<Skeleton
					loading={loading}
					active={loading}
					size={"large"}
					block={true}
					style={{
						height: "6em",
					}}
					paragraph={{
						rows: 2,
						width: "100%",
					}}
				>
					<div className={`dashboard-data-each`}>
						<p className={`sub-title`}>
							카테고리 조회
							<p>지난 30일</p>
						</p>
					</div>
					<div className={`dashboard-data-each`}>
						<p>총 조회수</p>
						<p>{totalCount?.toLocaleString()}</p>
					</div>
				</Skeleton>
			</div>
			<div className={`dashboard-each-data-div`}>
				<Skeleton
					loading={loading}
					active={loading}
					size={"large"}
					block={true}
					style={{
						height: "6em",
					}}
					paragraph={{
						rows: 5,
						width: "100%",
					}}
				>
					<div className={`dashboard-data-each`}>
						<p className={`sub-title`}>
							인기 카테고리
							<div style={{ display: "flex" }}>
								<p>전체 조회수</p>
							</div>
						</p>
					</div>
					{categoryList?.map((item, idx) => (
						<div className={`dashboard-data-each`} key={`best-category-${idx}`}>
							<p style={{ width: "90%" }}>{convertCategory(item)}</p>
							<p style={{ width: "10%", textAlign: "center" }}>
								{item?.view_num?.toLocaleString()}회
							</p>
						</div>
					))}
				</Skeleton>
			</div>
			<div className={`dashboard-each-data-div`}>
				{soarLoading && (
					<Spin
						style={{
							margin: "auto",
							width: "100%",
							paddingTop: "2em",
							position: "absolute",
							left: 0,
							right: 0,
						}}
					/>
				)}
				<Skeleton
					loading={loading}
					active={loading}
					size={"large"}
					block={true}
					style={{
						height: "6em",
					}}
					paragraph={{
						rows: 5,
						width: "100%",
					}}
				>
					<div className={`dashboard-data-each`}>
						<p className={`sub-title`} style={{ width: "100%" }}>
							급상승 카테고리
							<div
								style={{
									display: "flex",
									width: "100%",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								{/*<p>지난 30일</p>*/}
								{/*<p>ㆍ</p>*/}
								<div style={{ display: "flex" }}>
									<p>전체 조회수</p>
									<p>ㆍ</p>
									<p>
										{/*{dateLength}일 전*/}
										이틀 전
									</p>
								</div>
								{/*<Dropdown*/}
								{/*    overlay={dropdownItems}*/}
								{/*    trigger={"click"}*/}
								{/*    className={`dashboard-category-dropdown`}*/}
								{/*>*/}
								{/*    <Button*/}
								{/*        size={`small`}*/}
								{/*        style={{}}*/}
								{/*    >*/}
								{/*        {dateLength === 7 ? "일주일 전" : dateLength === 30 ? "한달 전" : `${dateLength}일 전`}*/}
								{/*        <img*/}
								{/*            src={`/assets/images/report/down.png`}*/}
								{/*            alt={`드롭다운`}*/}
								{/*            style={{*/}
								{/*                width: "1em",*/}
								{/*                height: "1em",*/}
								{/*                marginLeft: "3px"*/}
								{/*            }}*/}
								{/*        />*/}
								{/*    </Button>*/}
								{/*</Dropdown>*/}
							</div>
						</p>
					</div>
					{soarList?.length ? (
						<>
							{soarList?.map((item, idx) => (
								<div
									className={`dashboard-data-each`}
									key={`best-category-${idx}`}
								>
									<p style={{ width: "70%" }}>
										{convertCategory(item)}
										{item?.view_num > 300 && (
											<span
												style={{
													backgroundColor: "#fe2b4b",
													color: "white",
													marginLeft: "0.5em",
													padding: "3px 6px",
													borderRadius: "6px",
													fontSize: "0.9em",
												}}
											>
												HOT
											</span>
										)}
									</p>
									<p style={{ width: "15%", textAlign: "center" }}>
										{item?.total_count?.toLocaleString()}회
									</p>
									<p
										style={{
											width: "15%",
											textAlign: "center",
											color: "#ff8000",
										}}
									>
										{item?.view_num?.toLocaleString()}회 증가
									</p>
								</div>
							))}
						</>
					) : (
						<Row
							align={"middle"}
							style={{
								width: "100%",
								flexDirection: "column",
								padding: "2em 0",
							}}
						>
							<img
								src={`/assets/images/warning.png`}
								alt={`warning-icon`}
								style={{
									width: "3em",
									height: "auto",
								}}
							/>
							<p
								style={{
									marginTop: "1em",
									color: "#adb5bd",
									fontSize: "1.1em",
									fontWeight: 500,
								}}
							>
								최근 조회된 카테고리 게시물이 없습니다.
							</p>
						</Row>
					)}
					<p
						style={{
							fontSize: "0.8em",
							color: "#adb5bd",
						}}
					>
						* 조회수가 300회 이상 증가한 카테고리는 HOT으로 표기됩니다.
					</p>
				</Skeleton>
			</div>
			<Link to={"/reports_analysis/category"}>카테고리 분석으로 이동</Link>
		</div>
	);
};

export default DashboardCategory;
